import { render, staticRenderFns } from "./FlashSaleFloor.vue?vue&type=template&id=2ffcbbb3&scoped=true"
import script from "./FlashSaleFloor.vue?vue&type=script&lang=js"
export * from "./FlashSaleFloor.vue?vue&type=script&lang=js"
import style0 from "./FlashSaleFloor.vue?vue&type=style&index=0&id=2ffcbbb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffcbbb3",
  null
  
)

export default component.exports